import THEME from '@maxpreps/shared/styles/colors';

const getContestResultColor = (result: string): string => {
  switch (result) {
    case 'W':
      return THEME.status.positive;
    case 'L':
      return THEME.brand.maxpreps;
    case 'T':
    default:
      return THEME.text.tertiary;
  }
};

export default getContestResultColor;
